import styled from 'styled-components';

export const CarouselContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem auto;
    perspective: 1200px;
    position: relative;
    width: 100%;
    max-width: 500px;
    height: 500px;
    padding-bottom: 80px;
    overflow-x: hidden; /* <--- ¡NUEVO Y CLAVE! */

    @media (max-width: 480px) {
        max-width: 100%; /* <--- MODIFICADO */
        height: 450px;
    }
`;

export const CarouselWrapper = styled.div`
    position: relative;
    width: 90vw; /* <--- MODIFICADO: De 420px a 85vw */
    max-width: 450px; /* Se añade para limitar en escritorio */
    height: 400px;
    transform-style: preserve-3d;

    @media (max-width: 480px) {
        width: 95vw; /* <--- MODIFICADO: De 280px a 90vw */
        height: 380px;
    }
`;

export const CarouselCard = styled.div`
    position: absolute;
    left: 50%; /* <--- AÑADIDO: Para centrar la tarjeta antes de las transformaciones 3D */
    transform: translateX(-50%); /* <--- AÑADIDO: Para centrar la tarjeta */
    width: 80%;
    height: auto; /* <--- MODIFICADO: Altura automática para el contenido */
    max-width: 320px; /* <--- AÑADIDO: Ancho máximo para que no crezca demasiado */
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    cursor: pointer;

    &.active {
        transform: translateZ(200px) rotateY(0deg) translateX(-50%); /* Asegura el centrado inicial */
        opacity: 1;
        visibility: visible;
        z-index: 3;
    }

    &.prev {
        transform: translateZ(100px) rotateY(-25deg) translateX(calc(-50% - 30%)); /* Ajuste basado en el nuevo centrado */
        opacity: 0;
        visibility: hidden;
        z-index: 2;
    }

    &.next {
        transform: translateZ(100px) rotateY(25deg) translateX(calc(-50% + 30%)); /* Ajuste basado en el nuevo centrado */
        opacity: 0;
        visibility: hidden;
        z-index: 2;
    }

    &.inactive {
        transform: translateZ(-100px) rotateY(0deg) scale(0.8);
        opacity: 0;
        visibility: hidden;
        z-index: 1;
    }

    @media (max-width: 480px) {
        &.active {
            transform: translateZ(150px) rotateY(0deg) translateX(-50%); /* Asegura el centrado inicial */
        }

        &.prev {
            transform: translateZ(80px) rotateY(-20deg) translateX(calc(-50% - 25%));
        }

        &.next {
            transform: translateZ(80px) rotateY(20deg) translateX(calc(-50% + 25%));
        }
    }
`;

export const CardContent = styled.div`
    text-align: center;
    color: white;
    width: 100%;
`;

export const CardIcon = styled.div`
    /* Ajustamos el tamaño del contenedor para la imagen */
    width: 100px; /* Tamaño fijo para consistencia */
    height: 100px; /* Aseguramos que sea cuadrado */
    margin: 0 auto 1.5rem auto; /* Centramos el bloque y mantenemos el margen inferior */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden; /* Opcional: recorta si la imagen es más grande */

    /* La sombra de antes se aplicaba al texto, ahora la movemos al contenedor si queremos el mismo efecto */
    /* filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)); // Puedes mantenerla si el efecto sigue siendo bueno */

    & img {
        /* Aseguramos que la imagen dentro del div se ajuste al contenedor sin distorsión */
        max-width: 100%;
        max-height: 100%;
        object-fit: contain; /* Para que la imagen se contenga dentro de las dimensiones */
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)); /* Aplicamos la sombra a la imagen si lo deseas */
    }
`;

export const CardTitle = styled.h2`
    font-size: 1.8rem;
    margin-bottom: 1rem;
    font-weight: 700;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 480px) {
        font-size: 1.5rem;
    }
`;

export const CardText = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    opacity: 0.9;
    color: rgba(255, 255, 255, 0.9);

    @media (max-width: 480px) {
        font-size: 0.9rem;
    }
`;

export const CtaButton = styled.a`
    display: inline-block;
    padding: 12px 32px;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    color: white;
    text-decoration: none;
    border-radius: 25px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(107, 91, 255, 0.4);
    font-size: 0.9rem;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(107, 91, 255, 0.6);
        color: white;
    }
`;

export const CarouselNavigation = styled.div`
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: 2rem;
    margin-top: 2rem;
`;

export const NavButton = styled.button`
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    color: white;
    border: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(107, 91, 255, 0.3);

    &:hover {
        transform: translateY(-3px) scale(1.1);
        box-shadow: 0 8px 25px rgba(107, 91, 255, 0.5);
    }
`;

export const CarouselIndicators = styled.div`
    display: flex;
    gap: 0.8rem;
`;

export const Indicator = styled.button`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
        background: linear-gradient(135deg, #ff6b8b, #6b5bff);
        transform: scale(1.3);
    }

    &:hover {
        background: rgba(255, 255, 255, 0.6);
        transform: scale(1.2);
    }
`;